import * as types from '../constants'

import API_LOCATIONS from '@api/locations'

export const updateAllLocations = payload => ({
  type: types.UPDATE_LOCATIONS,
  payload,
})

export const getAllLocations = () => (dispatch) => {
  return API_LOCATIONS.getAllLocations().then((response) => {
    dispatch(updateAllLocations(response))
  })
}

export const updateNeighborhood = payload => ({
  type: types.UPDATE_NEIGHBORHOOD,
  payload,
})

export const getNeighborhoodPage = (payload) => (dispatch) => {
  const { url } = payload
  return API_LOCATIONS.getNeighborhoodPage(url).then((response) => {
    dispatch(updateNeighborhood(response))
  })
}



// WEBPACK FOOTER //
// ./src/store/locations/actions.js